var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FEC33C;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,46c0.6,2.4,1.3,4.7,1.9,7.1c2.7,9.5,6.4,18.5,12.9,26c1.3,1.6,1,2.4-0.7,3.1c-9.7,4.3-19.4,4.3-29.1-0.1 c-1.4-0.6-2-1.4-0.8-2.8c8-9.1,11.9-20.2,14.7-31.7c0.1-0.5,0.3-1.1,0.5-1.6C49.8,46,50,46,50.2,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,48.9c-0.7-0.8-1.4-1.5-1.9-2.4c-4.8-8.1-6.5-16.9-6.2-26.2c0-0.9,0.8-2.3,1.5-2.5 c3.6-1.2,7.2-2.2,10.9-3.1c1.7-0.4,2.6,0.5,2.6,2.4c-0.2,10.3-1.6,20.3-5.3,29.9c-0.2,0.5-0.4,0.9-0.7,1.3 C42.8,48.4,42.6,48.5,42.1,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,48.8c-1-3.1-2.4-6.2-2.9-9.4c-1.2-7.3-2-14.6-3-21.9c-0.3-2.3,0.8-3.4,3-2.9c3.5,0.9,7,1.9,10.4,3.1 c0.7,0.3,1.5,1.6,1.5,2.5c0.3,9.5-1.6,18.5-6.5,26.7c-0.4,0.7-1,1.2-1.5,1.8C57.4,48.8,57.1,48.8,56.8,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,49.2c0.6-11.4,5.1-20.8,14.2-27.8c0.6-0.5,1.4-0.6,2.2-0.9c0.2,0.8,0.5,1.6,0.5,2.3 c-0.5,7.3-1.8,14.5-5.4,21c-2,3.7-4.7,6.6-8.2,8.8c-0.8,0.5-1.8,0.6-2.7,0.8c-0.2-0.9-0.5-1.7-0.6-2.6C15,50.4,15.1,49.8,15.1,49.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,49.5c-0.3,1.3-0.6,2.6-0.9,4c-1.3-0.5-2.8-0.9-3.9-1.7c-6-4.4-9-10.7-10.7-17.7c-0.9-3.7-1.2-7.5-1.6-11.3 c-0.1-0.7,0.3-1.5,0.5-2.3c0.7,0.3,1.6,0.4,2.1,0.9C79.6,28.5,84.2,38,85,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,45.1c0.8,1.7,1.5,3.2,2.2,4.6c0.5,1,1.1,2.1,1.9,2.9c2.8,2.6,2.1,5,0.2,7.8c-3,4.5-6.5,8.5-10.8,11.8 c-1.7,1.3-3,1.2-4.1-0.7c-1.4-2.4-3-4.8-4.2-7.3c-0.3-0.7,0.1-2.5,0.6-2.8c6.4-3.4,10.6-8.6,13.3-15.2 C32.2,45.9,32.4,45.7,32.9,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,45.3c0.4,0.7,0.8,1.3,1.1,2c2.5,5.9,6.4,10.7,12.1,13.6c1.9,1,2.2,2.1,1.2,3.8c-1.4,2.4-2.8,4.7-4.2,7 c-1,1.5-2.3,1.7-3.8,0.6c-5.4-4-9.4-9-12.6-14.9c-0.3-0.5-0.4-1.4-0.2-1.9C62.7,52.2,64.9,48.9,67.1,45.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank03);
export default __webpack_public_path__ + "static/media/icon-bank-03.9582b6896d9385cb84dede21cd415dc8.svg";
export { ForwardRef as ReactComponent };